import React from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import 'react-day-picker/lib/style.css';
import Auth from '../api/ApiSession';
import './styles.css';
import ChoosePeriod from '../components/choosePeriod';
import useImpactMetricsGraphDetails from './useImpactMetricsGraphDetails';
import moment from 'moment'
import { useSelector } from 'react-redux'
import withCommonLandscape from '../hocs/withCommonLandscape';
import API_CONFIG from "../api/API_CONFIG";

const authCall = new Auth();
const CapacityUtilizationDetails = (props) => {
    const userObj = useSelector((state)=> state.user)
    const [utilityDetails, setUtilityDetails] = React.useState({})
    const [utilityDetailsCopy, setUtilityDetailsCopy] = React.useState({})
    const [selectedCheckBox, setSelectedCheckBox] = React.useState([])
    const [snackBarObj, setSnackBarObj] = React.useState({})
    const [progressbarData, setProgressbarData] = React.useState([])
    const [capacityUtilization, setCapacityUtilization]= React.useState();
    const [isLoading, setIsLoading] = React.useState(false)
    const [graphType, setGraphType] = React.useState({
        barGraphClass: "iconBtnLeft active",
        lineGraphClass: "iconBtnRight",
        type: 'Bar'
    })
    const [dataToPost, setDataToPost] = React.useState({
        type: "Capacity Utilization",
        granularity: null,
        startDate: null,
        endDate: null,
        siteName: sessionStorage.getItem("siteName"),
        customerId: parseInt(sessionStorage.getItem("customerId")),
        customerType: sessionStorage.getItem("customerType"),
        graphType:graphType.type
    })
    const intervalRef = React.useRef()
    let idToPrint = []
    let dataValue = {}
    let options = {}
    const onPeriodChange = (startDate, endDate, type) => {
        let dataTopost1 = dataToPost
        console.log(dataTopost1)
        dataTopost1.startDate = startDate
        dataTopost1.endDate = endDate
        dataTopost1.granularity = type
        setDataToPost(dataTopost1)
        fetchUtilityDetails('normalCall')
    }
    const { renderCapacityGraphDetails } = useImpactMetricsGraphDetails(utilityDetails, graphType, idToPrint, dataValue, options, utilityDetails.widgetType)
    const fetchUtilityDetails = (call) => {
        call === "normalCall" ? setIsLoading(true) : setIsLoading(false);
        
        let _dataTopost = dataToPost
        if(_dataTopost.startDate === "Invalid date"){
            _dataTopost.startDate=moment(new Date()).format('YYYY-MM-DD')
        }
        
        authCall.postAgroDashboardDetails(_dataTopost).then(json => {
            if (json) {
                setIsLoading(false);
                let jsonCopy = JSON.parse(JSON.stringify(json));
                removeDataFromGraph(jsonCopy)
                setProgressbarData(json.widgetData)
                setUtilityDetailsCopy(json)
                setCapacityUtilization(json.widgetData[0].propVal)
            }
        })
    }
    React.useEffect(() => {
        intervalRef.current = setInterval(() => {
            fetchUtilityDetails('initialCall')
        }, 900000);
        return () => {
            clearInterval(intervalRef.current)
        }
    }, [])
    const removeDataFromGraph = (jsonCopy) => {
        _.map(selectedCheckBox, ele => {
            _.map(jsonCopy.widgetDetails, widgetDetail => {
                let i = 0;
                while (i < widgetDetail.graphData.length) {
                    if (widgetDetail.graphData[i].propName === ele) {
                        widgetDetail.graphData.splice(i, 1)
                        i = 0;
                    } else {
                        i++;
                    }
                }
            })

            let j = 0;
            while (j < jsonCopy.widgetData.length) {
                if (jsonCopy.widgetData[j].propName === ele) {
                    jsonCopy.widgetData.splice(j, 1)
                    j = 0;
                } else {
                    j++;
                }
            }

        })
        setUtilityDetails(jsonCopy)
    }
    const changeToBarGraph = () => {
        setGraphType({
            barGraphClass: "iconBtnLeft active",
            lineGraphClass: "iconBtnRight",
            type: "Bar"
        })
        dataToPost.graphType="bar"
    }
    const changeToLineGraph = () => {
        setGraphType({
            barGraphClass: "iconBtnLeft",
            lineGraphClass: "iconBtnRight active",
            type: "Line"
        })
        dataToPost.graphType="Line"
    }
    const navigateToOverview = () => {
        let { history } = props;
        history.push({
            pathname: '/overview'
        });

    }
    const onCheckBoxClicked = (selected, selectedData) => {
        let utilityDetails1 = JSON.parse(JSON.stringify(utilityDetailsCopy));
        if (selected === false) {
            if (selectedCheckBox.indexOf(selectedData.propName) === -1) {
                selectedCheckBox.push(selectedData.propName)
            }
        } else {
            if (selectedCheckBox.indexOf(selectedData.propName) !== -1) {
                selectedCheckBox.splice(selectedCheckBox.indexOf(selectedData.propName), 1)
            }
        }
        removeDataFromGraph(utilityDetails1)
    }
    const generateReport = async() => {
        setIsLoading(true)
        let access_token = sessionStorage.getItem("access_token");  
        let reqUrl = {API_CONFIG}.API_CONFIG.baseUrl+{API_CONFIG}.API_CONFIG.endpoints.donwloadPdfReport;
            console.log("PPR ALZ Endpoint", reqUrl);           
            const response = await fetch(reqUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "Authorization":`Bearer ${access_token}`,
              },
              body: JSON.stringify(dataToPost),
            });   
            setIsLoading(false);           
              const blob = await response.blob();
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.download = "example.pdf"; 
              document.body.appendChild(link);
              link.click();
              link.remove();
              window.URL.revokeObjectURL(url);
         //Old code     
        // authCall.postGeneratePdfReport(dataToPost).then(json => {
        //     if (json) {
        //         setIsLoading(false)
        //         let a = document.createElement("a")
        //         a.href =json.includes("\"https://")? "https://"+json.replace("\"https://",'').replace('"',''):json
        //         a.target= '_blank'
        //         a.click()

        //     }else{
        //         setIsLoading(false)
        //         document.getElementById('admin-snackbar').open = true;
        //         setSnackBarObj({ type: "warning", msg: "Failed to generate PDF" })
        //     }
        // })
        // let idData = []
        // let serachString = "summary"
        // let domtoImageID = _.filter(idToPrint, function (o) { return o.toLowerCase().indexOf(serachString.toLowerCase()) !== -1 })
        // domtoimage.toPng(document.getElementById(domtoImageID[0])? document.getElementById(domtoImageID[0]) : document.createElement("DIV")).then(function (dataURL) {
        //     domtoimage.toPng(document.getElementById(domtoImageID[1])? document.getElementById(domtoImageID[1]) : document.createElement("DIV")).then(function (dataURL2) {
        //         _.map(domtoImageID, (eachDomToImage, index) => {
        //             if (index === 0) {
        //                 idData.push({ chart: dataURL })

        //             } else {
        //                 idData.push({ chart: dataURL2 })
        //             }
        //             idData.push({ chart: document.getElementById(utilityDetails.widgetType + 'Graph1234' + index).toDataURL('image/png') })
        //             idData.push({ tableData: document.getElementById(utilityDetails.widgetType + 'Table1234' + index).innerHTML })
        //         })
        //         let selectedSite;
        //         if (sessionStorage.getItem("siteName") === "") {
        //             selectedSite = "All Sites"
        //         } else {
        //             selectedSite = sessionStorage.getItem("siteName")
        //         }
        //         let jsonToPost = {
        //             "reportAPI": "saveReportData",
        //             "reportParam": ,
        //             "reportSite": selectedSite,
        //             "reportCustomer": sessionStorage.getItem("customerId"),
        //             "reportUserid": ,
        //             "customerType": sessionStorage.getItem("customerType"),
        //             "reportDataList": [
        //                 {
        //                     "reportType": dataToPost.granularity,
        //                     "reporWidgetName": "Capacity Utilization",
        //                     "fromDate": dataToPost.startDate,
        //                     "toDate": dataToPost.endDate,
        //                     "reportTableData": idData
        //                 }
        //             ]
        //         }
        //         authCall.postGeneratePdfReport(jsonToPost).then(json => {
        //             if (json) {
        //                 setIsLoading(false)
        //                 let a = document.createElement("a")
        //                 a.href = json
        //                 a.click()

        //             }
        //         })
        //     })
        // })
    }
    const isMobile = window.innerWidth <= 600;
    const renderCheckBoxList = _.map(progressbarData, (ele, index) => {
        return <div key={index} class="row align-items-center">
            <div class="col-md-12">
                <span>{ele.propName}</span>
                <span style={{ float: "right" }}>
                    <se-checkbox selected="true" onClick={(e) => onCheckBoxClicked(e.target.selected, ele)}></se-checkbox>
                </span>
            </div>
        </div>
    })
    return <se-container position="absolute" direction="row" >
        {isLoading ? <div class="align-items-center"><se-loading loading="true"></se-loading></div> : null}
        <se-block>
            <se-block-header class="headerColor"><span class="font-size-22">
                {utilityDetails.widgetType}-{sessionStorage.getItem("siteName") !== "" ?
                    sessionStorage.getItem("siteName") : "All Sites"}</span>
                <div slot="end"><se-icon option="" class="pointer" onClick={() => navigateToOverview()}>action_close</se-icon>&nbsp;&nbsp;&nbsp;&nbsp;</div>
            </se-block-header>
            <se-block-content class="grey-backgroundCreate" >
                <se-container position="absolute" direction="row" margin="large" padding="large">
                    <div class="col-md-4 col-lg-3 col-xl-3 px-0" option="widget" margin="none" style={{background:"white"}}>
                        <div class="border-bottom divDetailsHeight text-left">
                            <span class="font-normal font-weight-400">Last updated: {utilityDetails.lastUpdated}</span>
                        </div>
                        <div class="border-bottom">
                            <se-block-content>
                                <ChoosePeriod onChange={onPeriodChange}
                                    disabled={["Weekly", "Daily"]} checkedValue="LifeTime"
                                    InstaltedDate={utilityDetails.installationDate} />
                            </se-block-content>
                        </div>
                        <se-block-content class="ChooseDivHeight">
                            <div class="rows">
                                <span className="font-size-22">{sessionStorage.getItem('customerType')==="SWP"?"Capacity":"Energy"} Utilization</span>
                            </div>
                            <span class='hideinMobile'>{renderCheckBoxList}</span>
                            
                            {isMobile && 
                            (<>
                            <se-icon size="large">measurement_metering</se-icon>
                              <span style={{fontSize:"55px", marginLeft:"10px", marginBottom:"10px"}}>{capacityUtilization}</span>
                              <span>%</span>
                              </>
                              )}
                        </se-block-content>
                    </div>
                    <se-divider option="vertical"></se-divider>
                    <se-block class="px-0 hideinMobile">
                        <div class="mt-30px">
                            <div class="rows pdf-download">
                                <div className="mt-2 toggleBtn">
                                    <span onClick={() => changeToBarGraph()} className={graphType.barGraphClass}>
                                        <se-icon >graph_barchart</se-icon>
                                    </span>
                                    <span onClick={() => changeToLineGraph()} className={graphType.lineGraphClass}>
                                        <se-icon >energy</se-icon></span>
                                </div>
                                <se-icon option="button" onClick={() => generateReport()} size="large">action_pdf_report</se-icon>
                            </div>
                            <se-block-content>
                                {renderCapacityGraphDetails()}
                            </se-block-content>
                        </div>
                    </se-block>
                </se-container>
            </se-block-content>
        </se-block>
        <div style={{ position: "absolute", left: '15px' }}>
            <se-snackbar id="admin-snackbar" duration="5000" type={snackBarObj.type}
                message={snackBarObj.msg} ></se-snackbar>
        </div>
    </se-container>
}
export default withCommonLandscape(withRouter(CapacityUtilizationDetails));